export default "__VITE_ASSET__CUy7pxQw__"